import { StaffAccessLevels } from '@/enums/StaffAccessLevels';

export const getAccessLevelDisplayName = (accessLevel: StaffAccessLevels): string => {
  if (accessLevel === StaffAccessLevels.HomeAdmin) return 'Home Admin';
  if (accessLevel === StaffAccessLevels.HomeUser) return 'Home User';
 
  return accessLevel;
};

export const getStaffAccessLevels = (isEnabledStaffAPI: boolean, hasMaintenanceFeature: boolean): Array<{ text: string; value: StaffAccessLevels }> => {

  if (isEnabledStaffAPI && hasMaintenanceFeature) {
    return [ 
         { text: 'Maintenance Admin', value: StaffAccessLevels.MaintenanceAdmin }, 
         { text: 'Maintenance User', value: StaffAccessLevels.MaintenanceUser }
      ];
  } else {
     const accessLevels = [
         { text: 'Home User', value: StaffAccessLevels.HomeUser },
         { text: 'Home Admin', value: StaffAccessLevels.HomeAdmin },
         { text: 'Org Admin', value: StaffAccessLevels.OrgAdmin },
    ];
    if (hasMaintenanceFeature) {
         accessLevels.push({ text: 'Maintenance Admin', value: StaffAccessLevels.MaintenanceAdmin });
         accessLevels.push({ text: 'Maintenance User', value: StaffAccessLevels.MaintenanceUser });
    }
    return accessLevels;
  }
};
